import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=1cb8d82c"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=1cb8d82c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports